import React from 'react';
import cn from 'classnames';
import { withStyles } from '@material-ui/styles';
import { styles } from './styles';
import { Props } from './types';
import ParentExpansion from './ParentExpansion';

export const HierarchicalSlides = withStyles(styles)(
  class HierarchicalSlides extends ParentExpansion<Props> {
    readonly panel: React.RefObject<HTMLDivElement>;

    constructor(props) {
      super(props);
      this.panel = React.createRef();
    }

    render() {
      const { className, classes } = this.props;
      return <div ref={this.panel} className={cn(className, classes.root)}>
        {this.boundChildren}
      </div>
    }
  })

export default HierarchicalSlides;

export * from './shared/GlobalCategory';
export * from './shared/Category';
export * from './shared/Subcategory';
export * from './shared/Slide';
